import React from "react";

export const About = () => {
  return (
    <>
      <div className="visa-big-box container">
        <div className="heading">
          <h1>IHCI Society</h1>
        </div>
        <h5>
        The Intelligent Human Computer Interaction (IHCI) society, established in 2008, is a continuously growing community of researchers, educators, and young professionals focused on the fields of Intelligent Human Computer Interaction and Cognitive Computing. The society's mission is to foster the advancement of human-centered technology, cognitive computing, and humanities studies through the implementation of research and experimental development initiatives.
        </h5>

        <h5>
          The IHCI society conducts an annual International Conference and
          Workshop where the elite research minds of the field come together
          with young researchers to collaborate, share ideas for research, and
          achieve new horizons. The conference provides a forum for the
          presentation of research results and technological advances at the
          intersection of human-computer interaction, artificial intelligence,
          signal processing, and computer vision. It brings together engineers
          and scientists from around the world, focusing on theoretical,
          practical, and applicational aspects of the field.
        </h5>

        <h5>
          IHCI society has emerged as the foremost worldwide gathering of the
          field's academic researchers, graduate students, top research think
          tanks and industry technology developers. The Society aims to explore
          research challenges emerging in the complex interaction between
          machine intelligence and human intelligence. Society believes that the
          biggest benefit to the participant is the actualization of their goals
          in the field of HCI, which ultimately leads to greater success in
          business and is beneficial to society.
        </h5>

        <h5>
          The science and technology of Human-Computer Interaction (HCI) has
          made significant progress in recent years, resulting in two opposing
          trends. One trend is to organize separate conferences on focused
          topics such as Interaction Design and User-Centered Design, while the
          other trend is to assimilate new areas into HCI conferences such as
          Computing with Words, Prosocial Agents Development, and
          Attention-based Applications. IHCI is unique in that it focuses on
          issues of intelligence and human computer interaction at the
          intersection of these trends.
        </h5>
        <h5>
          By joining the IHCI society, members will have the opportunity to stay
          updated on the conferences and events the society conducts. The
          society's vision is to be a leading community of researchers,
          educators, and young professionals in the field, setting new
          benchmarks in research and advancing the understanding of Intelligent
          Human Computer Interaction and Cognitive Computing.
        </h5>
        <hr className="hr-style" />
        <div className="heading">
          <h1>Mission</h1>
        </div>
        <h5>
          The mission of the Intelligent Human-Computer Interaction (IHCI)
          society is to advance the field of Human-Computer Interaction through
          research and development, with a focus on fostering innovation and
          promoting progress. We aim to facilitate the exchange of ideas and
          knowledge among researchers from around the world, with a particular
          emphasis on supporting R&D in underdeveloped countries and regions.
          Our annual conference and various workshops, symposia, and meetings
          serve as a platform for engineers and scientists to present and
          discuss the latest advancements in HCI, Artificial Intelligence,
          Signal Processing, and Computer Vision. Our goal is to explore the
          complex relationship between machine and human intelligence and to
          provide a forum for addressing research challenges and shaping the
          future of the field.
        </h5>
        <hr className="hr-style" />
        <div className="heading">
          <h1>Vision</h1>
        </div>
        <h5>
          The vision of the IHCI society is to be a global leader in advancing
          the field of Human-Computer Interaction through cutting-edge research
          and development. We aim to create a collaborative platform that brings
          together researchers from all over the world to exchange ideas, share
          knowledge, and drive innovation in the field. Our ultimate goal is to
          shape the future of HCI through our efforts, ultimately leading to a
          more seamless and intuitive human-computer experience for all.
        </h5>
        <br />
        <hr className="hr-style" />
      </div>
    </>
  );
};
